import Config from "../../assets/js/config";

const config = new Config();

let closestPages;

let setPages = (index, lastPage, currentPage) => {
    let minValue = index;
    let maxValue = lastPage.number - (5 - index);
    let placeOnView = index - 3;
    let currentValue = currentPage.number + placeOnView;

    maxValue = (maxValue <= index) ? index : maxValue;

    if(currentValue > minValue){

        if(currentValue < maxValue){
            closestPages[index-1] = {number:currentValue};
        } else {
            closestPages[index-1] = {number:maxValue};
        }

    } else {
        closestPages[index-1] = {number:minValue};
    }
};

export default {
    fillPagination: function(lastPage, currentPage){
        let numPages = (lastPage.number > 5) ? 5 : lastPage.number;

        closestPages = [];

        for(let i=1; i <= numPages; i++){
            setPages(i, lastPage, currentPage);
        }

        return closestPages;
    },

    getLastNumber:function (totalProductsNumber, currentNumPerPage) {
        return Math.ceil(totalProductsNumber/currentNumPerPage.value);
    },

    getCurrentNumPerPage: function(){
        let localStorageValue = localStorage.getItem('productsPerPage');
        let productsPerPage = localStorageValue ? JSON.parse(localStorageValue) : this.numbersPerPage[2];

        return productsPerPage;
    },
    setCurrentNumPerPage: function(value){
        localStorage.setItem('productsPerPage', JSON.stringify(value));
    },
    getDefaultSortItem: function(){
        return this.sortList[0];
    },
    getDefaultPage: function(){
        return {number:1};
    },
    getInitialPages: function (maxPages) {
        let pages = [];

        for(let i = 1; i < 6; i++){
            if(maxPages >= i){
                pages.push({number:i});
            }
        }

        return pages;
    },
    paginationArrowClick: function (scope, type) {
        if((type === 'prev') && (scope.currentPage.number !== 1)){
            scope.currentPage.number -= 1;
            this.fillPagination(scope.lastPage, scope.currentPage);

        } else if((type === 'next') && scope.currentPage.number !== scope.lastPage.number){
            scope.currentPage.number += 1;
            this.fillPagination(scope.lastPage, scope.currentPage);
        }
    },
    getStarImage: function (stars, indexCurrentStar) {
        let urlToReturn;
        if((stars < indexCurrentStar) && (stars >= (indexCurrentStar - 0.5))){
            urlToReturn = config.getDomain() + '/svg/icons.svg#icon-star-half';
        } else if(stars < indexCurrentStar){
            urlToReturn = config.getDomain() + '/svg/icons.svg#icon-star-outlined';
        } else {
            urlToReturn = config.getDomain() + '/svg/icons.svg#icon-star-filled';
        }

        return urlToReturn;
    },

    sortList:[
        {
            name:'popularity',
            title:'Populariteit',
            paramName: 'sortBy[popularity]',
            paramValue: 'desc',
            orderBy: 'popularity'
        },
        {
            name:'desc',
            title:'Prijs (hoog > laag)',
            paramName: 'sortBy[price]',
            paramValue: 'desc',
            orderBy: 'price'
        },
        {
            name:'asc',
            title:'Prijs (laag > hoog)',
            paramName: 'sortBy[price]',
            paramValue: 'asc',
            orderBy: 'price'
        },
        {
            name:'rating',
            title:'Meeste aantal beoordelingen',
            paramName: 'sortBy[rating]',
            paramValue: 'desc',
            orderBy: 'rating'
        },
    ],
    numbersPerPage: [
        {
            value:20
        },
        {
            value:40
        },
        {
            value:60
        },
        {
            value:100
        }
    ]
}
